module.exports = __webpack_public_path__ + "static/media/logo-white.1c6f7d0d.svg";